import { useGlobals } from '@/lib/store/hooks';
import Grid from '../ui/Grid';
import Txt from '../ui/Txt';

export default function ArticleDisclaimer() {
  const { articleDisclaimer } = useGlobals();

  const content = articleDisclaimer?.content;

  return content ? (
    <Grid>
      <Grid.Col offsetMd={2} md={8}>
        <Txt variant="small" html>
          {content}
        </Txt>
      </Grid.Col>
    </Grid>
  ) : null;
}
